import React, {Component} from 'react';
import './ResetPasswordComponent.less';
import {ButtonPrimary} from '@homeaway/react-buttons';

class ResetPasswordComponent extends Component {
    constructor(props) {
        super(props);
        this.returnToLogin = this.returnToLogin.bind(this);
    }

    returnToLogin() {
        this.props.updatePage('login');
    }

    render() {
        return (<div className="ResetPassword text-center">
            <div className="Padding">
                <svg width="56" height="44" xmlns="http://www.w3.org/2000/svg">
                    <g stroke="#323F4D" strokeWidth="1.5" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 1l26.293 26.293a1 1 0 0 0 1.414 0L55 1"/>
                        <path d="M1 1h54v39a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V1z"/>
                    </g>
                </svg>
            </div>
            <div><h3 className="Header text-400">{this.props.lingua.read('lex.password.reset.title')}</h3></div>
            <p className="Padding lead">{this.props.lingua.read('lex.password.reset.subtitle')}</p>
            <ButtonPrimary label={this.props.lingua.read('lex.password.reset.button')} onClick={this.returnToLogin}/>
        </div>);
    }
}

export default ResetPasswordComponent;
